import React from 'react';
import QuestionBox from './boxContentCreator';
import style from './contentCreatorQuestions.module.css'

const ContentCreatorQuestions = ({section}) => {
const { box1Title, box1Bodytext, box2Title, box2Bodytext } = section
 return (
     <section className={style.section}>
         <div className={style.container}>
            <QuestionBox heading={box1Title}
                         text={box1Bodytext}
                         buttonText="Get started"
                         link={'https://ohcleo.com/ohvoices'}></QuestionBox>
            <QuestionBox heading={box2Title}
                         text={box2Bodytext}
                         buttonText="Apply"
                         link={'https://career.ohcleo.com/'}
                         ></QuestionBox>
         </div>
     </section>
 )
}
export default ContentCreatorQuestions;